export const data_palace = {
   splat: "https://assets.deepworldmodel.ai/playground/scene/palace-260315142001_69b64f74598408189ecae08d-20260315_062024-pipeline-splat_30000.sog",
   mesh: "https://assets.deepworldmodel.ai/playground/scene/palace-260315142001_69b64f74598408189ecae08d-20260315_062024-pipeline-splat_30000_mesh.glb",
   avatar:
      "https://assets.deepworldmodel.ai/playground/avatar/labubuRun_20260630_1720.glb",
   scale: 0.5,
   camera: {
      position: {
         x: 0,
         y: 0.5,
         z: -2,
      },
      target: {
         x: 0,
         y: 0,
         z: 4,
      },
   },
   path: {
      position: [
         [-1.6541823148727417, -1.0292893648147583, -3.1176629066467285],
         [-1.6331638097763062, -1.0338590145111084, -2.8182969093322754],
         [-1.6420940160751343, -1.042330265045166, -2.515362501144409],
         [-1.5635182857513428, -0.9458010196685791, -2.236786127090454],
         [-1.350435495376587, -0.9583460092544556, -2.00809645652771],
         [-1.1397886276245117, -1.0536866188049316, -1.8002679347991943],
         [-0.9131629467010498, -1.0247058868408203, -1.5928596258163452],
         [-0.6114257574081421, -1.0376121997833252, -1.5372318029403687],
         [-0.31933313608169556, -0.9368468523025513, -1.511464238166809],
         [-0.0067719267681241035, -0.9203311204910278, -1.5138640403747559],
         [0.2947726547718048, -0.9234466552734375, -1.5234767198562622],
         [0.6042290329933167, -0.9374706745147705, -1.53128182888031],
         [0.9133419394493103, -0.9481025338172913, -1.5460668802261353],
         [1.1951454877853394, -0.8464649319648743, -1.5905288457870483],
         [1.472649335861206, -0.9008506536483765, -1.7070363759994507],
         [1.7308447360992432, -0.936888575553894, -1.8767118453979492],
         [1.9371694326400757, -0.9689446091651917, -2.1059694290161133],
         [2.077296733856201, -0.9573862552642822, -2.371218204498291],
         [1.879562497138977, -0.8700993061065674, -2.591092109680176],
         [1.6005667448043823, -0.8280133008956909, -2.4778635501861572],
         [1.465301752090454, -0.807232677936554, -2.2021334171295166],
         [1.2783783674240112, -0.7739765644073486, -1.9687228202819824],
         [1.0548585653305054, -0.9221206903457642, -1.7949602603912354],
         [0.7610183954238892, -0.9545509815216064, -1.7047594785690308],
         [0.4721923768520355, -1.0023869276046753, -1.7989537715911865],
         [0.17744435369968414, -0.9715135097503662, -1.8956385850906372],
         [-0.09426955133676529, -0.9254003763198853, -2.0405466556549072],
         [-0.3984791934490204, -0.9603673219680786, -2.1398777961730957],
         [-0.671518862247467, -0.9704653024673462, -2.2718043327331543],
         [-0.8232348561286926, -1.0424283742904663, -2.521540641784668],
         [-0.7527210712432861, -1.0617289543151855, -2.8365225791931152],
         [-0.7272776961326599, -1.0691722631454468, -3.13971209526062],
         [-0.8370569348335266, -1.0638387203216553, -3.4408674240112305],
         [-1.0142663717269897, -1.066871166229248, -3.688269853591919],
         [-1.2757419347763062, -1.0641627311706543, -3.8480031490325928],
         [-1.573170781135559, -1.0593719482421875, -3.8885276317596436],
         [-1.7836936712265015, -1.0431315898895264, -3.6723105907440186],
                  [-1.6541823148727417, -1.0292893648147583, -3.1176629066467285],
      ],
      target: [
         [-1.5130395796023177, -1.0297216176986694, -2.168712858543428],
         [-1.649815069620928, -1.0338590145111084, -1.8184355511702617],
         [-1.5707424095756997, -1.042330265045166, -1.5179112751438844],
         [-0.9423025168886238, -0.9458010196685791, -1.4531465616547234],
         [-0.6470420589265419, -0.9583460092544556, -1.297295729488833],
         [-0.3759351998712014, -1.0536866188049316, -1.1548781758863973],
         [-0.0059851291916993565, -1.0247058868408203, -1.1721121868235787],
         [0.3882652509951079, -1.0376121997833252, -1.5123744555820278],
         [0.6806298499588828, -0.9368468523025513, -1.5028603699199088],
         [0.9926224746690675, -0.9203311204910278, -1.5486610284052944],
         [1.2941794504524946, -0.9234466552734375, -1.5579158944581029],
         [1.6039528090589572, -0.9374706745147705, -1.554784415313651],
         [1.9130735906508893, -0.9481025338172913, -1.5692320606865682],
         [2.133118407642147, -0.8464649319648743, -1.9372373712306752],
         [2.333037996328616, -0.9008506536483765, -2.2166748291592326],
         [2.487474671119508, -0.936888575553894, -2.5305552069389456],
         [2.519058180270556, -0.9689446091651917, -2.919237825906728],
         [2.1178090109695296, -0.9573862552642822, -3.370397245212763],
         [0.9112686086639807, -0.8700993061065674, -2.341278287920908],
         [0.9383887883401746, -0.8280133008956909, -1.7285169321428877],
         [1.0484455572356748, -0.807232677936554, -1.293160968255958],
         [0.5033777249093959, -0.7739765644073486, -1.336762375236619],
         [0.16489078994508533, -0.9221206903457642, -1.3389368412826042],
         [-0.21886034968356283, -0.9545509815216064, -1.904353178085436],
         [-0.4636747593151691, -1.0023869276046753, -2.151306866429582],
         [-0.7454298863517326, -0.9715135097503662, -2.2807400484084486],
         [-1.033381962704236, -0.9254003763198853, -2.384156723632512],
         [-1.3590783330346101, -0.9603673219680786, -2.4178153665507343],
         [-1.3293760311307106, -0.9704653024673462, -3.024947045204651],
         [-0.8485670334829121, -1.0424283742904663, -3.521219730687949],
         [-0.3827917109301825, -1.0617289543151855, -3.765582463365464],
         [-0.970964805728655, -1.0691722631454468, -4.109565997978318],
         [-1.3001707075632152, -1.0638387203216553, -4.327166263854809],
         [-1.8068029374674897, -1.066871166229248, -4.298094247958243],
         [-2.2161413605270424, -1.0641627311706543, -4.188075082669706],
         [-2.567513410574158, -1.0593719482421875, -3.7823074110804673],
         [-1.2074398675641085, -1.0431315898895264, -2.8550397948846387],
                  [-1.5130395796023177, -1.0297216176986694, -2.168712858543428],
      ],
   },
};
